// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1WjKh","content":"styles_content__3rGCi","selectAll":"styles_selectAll__2fIv6"};